import { ConfiguratorIntegrations } from '@models';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, featureKey } from './reducer';

export const selectGetIntegrationsState = createFeatureSelector<State>(featureKey);

export const getIntegrationsGetData = createSelector(selectGetIntegrationsState, (state: State) => state.data);

export const getIntegrationsGetError = createSelector(selectGetIntegrationsState, (state: State) => state.error);

export const getIntegrationsGetLoading = createSelector(selectGetIntegrationsState, (state: State) => state.loading);

export const getIntegrationsMapData = <T>(fn: (data: ConfiguratorIntegrations) => T) =>
  createSelector(selectGetIntegrationsState, (state: State) => fn(state.data));

export const integrationGetRecoverPasswordUrl = createSelector(
  getIntegrationsGetData,
  (state: ConfiguratorIntegrations | null) => state?.recoverPasswordUrl
);

export const integrationGetContactFormUrl = createSelector(
  getIntegrationsGetData,
  (state: ConfiguratorIntegrations | null) => state?.contactFormUrl
);

export const integrationGetMyVertiStartIntegrationUrl = createSelector(
  getIntegrationsGetData,
  (state: ConfiguratorIntegrations | null) => state?.myVertiStartIntegrationUrl
);

export const integrationGetMyVertiFinishIntegrationUrl = createSelector(
  getIntegrationsGetData,
  (state: ConfiguratorIntegrations | null) => state?.myVertiFinishIntegrationUrl
);

export const integrationGetFooterCookiesUrl = createSelector(
  getIntegrationsGetData,
  (state: ConfiguratorIntegrations | null) => state?.footerCookiesUrl
);

export const integrationGetFooterPrivacyUrl = createSelector(
  getIntegrationsGetData,
  (state: ConfiguratorIntegrations | null) => state?.footerPrivacyUrl
);

export const integrationGetFooterAccessibilityUrl = createSelector(
  getIntegrationsGetData,
  (state: ConfiguratorIntegrations | null) => state?.footerAccessibilityUrl
);

export const integrationGetPrivacyInformationUrl = createSelector(
  getIntegrationsGetData,
  (state: ConfiguratorIntegrations | null) => state?.privacyInformationUrl
);

export const integrationGetGenesysChatConfig = createSelector(
  getIntegrationsGetData,
  (state: ConfiguratorIntegrations | null) => state?.genesysChatConfig
);

export const integrationGetPrivacyPolicyVersion = createSelector(
  getIntegrationsGetData,
  (state: ConfiguratorIntegrations | null) => state?.privacyPolicyVersion
);

export const integrationGetVertiCommercialPageUrl = createSelector(
  getIntegrationsGetData,
  (state: ConfiguratorIntegrations | null) => state?.vertiCommercialPageUrl
);
